import type { ReactElement } from 'react'
import type { IRoleLight } from '~/types/role'

import Section, { SectionItem } from '../../../shared/Section'

import LayoutGroups from '~/components/Layouts/Groups'

interface Props {
  roles?: IRoleLight[]
}

const AuthDetailsGroups = ({ roles = [] }: Props): ReactElement => {
  return (
    <LayoutGroups>
      <Section itemsCount={roles.length} title="Owner roles">
        {roles.map(({ description, name, role_id }) => (
          <SectionItem key={role_id}>
            <div className="item-body">
              <div className="item-title">{name}</div>
              <div className="item-subtitle">{description}</div>
            </div>
          </SectionItem>
        ))}
      </Section>
    </LayoutGroups>
  )
}

export default AuthDetailsGroups
